<template>
    <section class="chart-container" >
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini" >
                <el-form-item label="项目名称">
					<el-select v-model="filters.projectId" multiple collapse-tags  @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="MN码">
					<el-select v-model="filters.mn"  multiple collapse-tags   style="width:280px" filterable reserve-keyword @change="getFactorsByMn" :filter-method="filterChange">
                        <el-option value="全选" label="全选"></el-option>
                        <el-option value="取消全选" label="取消全选"></el-option>
						<el-option
							v-for="item in devicesFil"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="数据类型">
					<el-select v-model="filters.dataType" placeholder="请选择数据类型" >
						<el-option label="分钟" value="minute"></el-option>
						<el-option label="小时" value="hour"></el-option>
						<el-option label="天" value="day"></el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" :picker-options="pickerOptionsHour"  :default-time="dafTime" range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="dataAdd">补录</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<el-table :data="resultDataList" border stripe highlight-current-row v-loading="listLoading" style="width: 100%;" :max-height="formHeight"   size="small" >
			<el-table-column type="index" label="序号" ></el-table-column>
			<el-table-column prop="mn" label="MN" ></el-table-column>
			<el-table-column prop="status" label="补传状态" >
				<template slot-scope="scope">
					<span v-if="scope.row.status=='true'" style="color:green">命令下发成功</span>
					<span v-else style="color:red">命令下发失败</span>
				</template>
			</el-table-column>
		</el-table>
    </section>
</template>

<script>
    import {getProjects,getDevicesByProjectId,dataForwardForJL} from '../../api/api';
    import {formatDate,in_array} from '../../../static/fun.js';

    export default {
        data() {
            return {
                pickerOptionsHour: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                filters: {
                    mn: '',
                    projectId:'',
					time:[],
					dataType:'hour'
                },
                dafTime:['00:00:00','00:00:00'],
                projects:[],
                devices:[],
                devicesFil:[],
                copy:[],
				formHeight:0,
				listLoading:false,
				resultDataList:[]
            }
        },
        methods: { 
            filterChange(v){
                this.copy=Object.assign([],this.devices);
                if(!in_array({mnCode:'全选'},this.copy)){
                    this.copy.push( {mnCode:'全选'});
                }
                if(!in_array({mnCode:'取消全选'},this.copy)){
                    this.copy.push( {mnCode:'取消全选'});
                }
                var dev=v.split(",");
                //对绑定数据赋值
                this.devicesFil = this.copy.filter((item) => {
                    //如果直接包含输入值直接返回true
					if (item.mnCode=="全选"||item.mnCode=="取消全选") return true;
					else if(dev.toString()==""){
						return true;
					}
					else{
						var flag=false;
						dev.forEach(element => {
							if (item.mnCode.indexOf(element) !== -1&&element!="") {
								flag=true;
                            }
						});
						return flag;
					}
                })
			},
			//获取选中设备可监测的因子
            getFactorsByMn(){
                // this.getDevicename();
                if(this.filters.mn.toString()==""){
                    return;
                }
                else if(in_array('-2',this.filters.mn)||in_array('取消全选',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                else if(in_array('-1',this.filters.mn)||in_array('全选',this.filters.mn)){
                    this.filters.mn=[];
                    this.devicesFil.forEach(element => {
                        this.filters.mn.push(element.mnCode);
                    });
                }
            },
            //查询项目信息
			getProjects() {
                this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
                     
				});
			},
            //获取趋势分析数据
            dataAdd(){
				this.resultDataList=[];
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
				}
				for(var i=0;i<this.filters.mn.length;i++){
					var mn=this.filters.mn[i];
					let para = {
						type:this.filters.dataType,
						mn: mn,
                        startTime: starttime,
						endTime: endtime
					};
					this.listLoading = true;
					dataForwardForJL(para).then((res) => {
						this.listLoading = false;
						var code = res.data.code;
						var obj={};
						obj.mn=para.mn;
						obj.status='false';
						if(code=="200"||code==200){
							obj.status='true'
                        }
                        this.resultDataList.push(obj);
					});
				}
            },
            //获取设备列表
			getDevices() {
				this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId.toString(),
                };
                if(para.projectId==""){
                    return;
                }
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    
                    this.devices = res.data.data;
                    this.devicesFil=res.data.data;
                    this.filters.mn=[];
                    if( this.devices.length>0){
                        this.filters.mn.push(res.data.data[0].mnCode);
                    }
                    this.getFactorsByMn();

                    this.deviceMap=new Map();
                    this.devices.forEach(item => {
                        this.deviceMap.set(item.mnCode,item.name)
                    });

				});
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			var end = new Date();
			var start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24);
            this.filters.time= [formatDate(start), formatDate(end)];
            var nowDate=end.getHours()+":00:00";
            this.dafTime=[nowDate,nowDate];
            this.getProjects();

            Array.prototype.indexOf = function(val) { 
                for (var i = 0; i < this.length; i++) { 
                if (this[i] == val) return i; 
                } 
                return -1; 
            }; 
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// DataAddJL.vue?17ff9fa6